import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from '../../../../common/Select';
import styles from '../FormStyles.module.scss';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import {
  buildSelectOptionFromCountry,
  countries,
  getPlaceholderTextFromCountryCode,
} from '../../../../../constants/countries';
import SimpleInput from '../../../../common/SimpleInput';
import { cloneDeep } from 'lodash';
import { everyOtherCountryIsRequiredPopupHtml, requiredShipToCountryValues } from '../helpers/formValidator';
import { InfoTitle } from '../../../../common/InfoTooltip';
import { getSecondAccountIdConfigForSupplierRetailer } from '../../../../../services/accountIdService';

const TABLE_HEADERS = ['Country', 'Account Id'];
export default function ShipToCountryTable({ form, setForm, props, inputLayoutConfig }) {
  const { shouldShowSecondInput } = inputLayoutConfig;
  const secondAccountIdConfig = getSecondAccountIdConfigForSupplierRetailer(props.accountIdTypes);

  function addRow() {
    const nextCountryThatHasNotBeenSelected = getNextCountryThatHasNotBeenSelected(cloneDeep(form.mapping));
    const shouldSetValueToBeAnArray = secondAccountIdConfig.shouldShowSecondAccountIdInput;
    form.mapping[nextCountryThatHasNotBeenSelected.value] = shouldSetValueToBeAnArray ? ['', ''] : '';
    setForm({ ...form });
  }

  function removeRow(countryCode) {
    if (Object.keys(form.mapping) <= 1) return;
    delete form.mapping[countryCode];
    setForm({ ...form });
  }

  function setAccountIdForCountry(accountId, countryCode, options = {}) {
    if (options.hasOwnProperty('secondAccountIdIndex')) {
      form.mapping[countryCode][options.secondAccountIdIndex] = accountId;
    } else {
      form.mapping[countryCode] = accountId;
    }
    setForm({ ...form });
  }

  return (
    <table className={styles.dynamic_ship_to_country_table}>
      <tbody>
        <tr>
          {TABLE_HEADERS.map((tableHeader, idx) => (
            <th key={idx}>{tableHeader}</th>
          ))}
        </tr>
        {Object.keys(form.mapping).map((countryCode, idx, arr) => (
          <tr key={idx}>
            <td className={styles.country_selector_row}>
              {requiredShipToCountryValues.includes(countryCode) ? (
                <span className={styles.disabled_delete_icon}>
                  <InfoTitle content={everyOtherCountryIsRequiredPopupHtml}>
                    <FontAwesomeIcon icon={faMinusCircle} />
                  </InfoTitle>
                </span>
              ) : (
                <span>
                  <FontAwesomeIcon onClick={() => removeRow(countryCode)} icon={faMinusCircle} />
                </span>
              )}
              <Select
                onChange={(newCountryCode) => {
                  form.mapping[newCountryCode] = form.mapping[countryCode];
                  delete form.mapping[countryCode];
                  setForm({ ...form });
                }}
                options={countries.map(buildSelectOptionFromCountry)}
                value={getSelectValueFromMapping(form, countryCode) || countryCode}
                disabled={requiredShipToCountryValues.includes(countryCode)}
              />
            </td>
            <td className={styles.account_id_input}>
              {Array.isArray(form.mapping[countryCode]) ? (
                <div className={styles.two_account_ids_for_country}>
                  <div className={styles.second_account_id_for_country_input_wrap}>
                    <SimpleInput
                      value={form.mapping[countryCode][0]}
                      placeholder={getPlaceholderTextFromCountryCode(countryCode, 1)}
                      onChange={(e) =>
                        setAccountIdForCountry(e.target.value, countryCode, {
                          secondAccountIdIndex: 0,
                        })
                      }
                    />
                    <span className={styles.required_asterisk}></span>
                  </div>
                  {shouldShowSecondInput && (
                    <div className={styles.second_account_id_for_country_input_wrap}>
                      <SimpleInput
                        value={form.mapping[countryCode][1]}
                        placeholder={getPlaceholderTextFromCountryCode(countryCode, 2)}
                        onChange={(e) =>
                          setAccountIdForCountry(e.target.value, countryCode, {
                            secondAccountIdIndex: 1,
                          })
                        }
                      />
                      {secondAccountIdConfig.isOptional ? '' : <span className={styles.required_asterisk}></span>}
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <SimpleInput
                    value={form.mapping[countryCode] || ''}
                    placeholder={`my-account-id-for-${countryCode}`}
                    onChange={(e) => setAccountIdForCountry(e.target.value, countryCode)}
                  />
                  <span className={styles.required_asterisk}></span>
                </>
              )}
            </td>
          </tr>
        ))}
        <tr id="addAdditionalRowPlaceholder" className={styles.add_additional_row_placeholder} onClick={addRow}>
          <td>
            <span>Add Country</span>
            <FontAwesomeIcon color={'#808080'} icon={faPlusCircle} />
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  );
}

function getNextCountryThatHasNotBeenSelected(currentMapping) {
  return getAvailableCountries(currentMapping)[0];
}

function getAvailableCountries(currentMapping) {
  if (!currentMapping || Object.keys(currentMapping).length === 0) return countries;
  return countries.filter((country) =>
    Object.keys(currentMapping).every((countryCode) => countryCode !== country.value),
  );
}

function getSelectValueFromMapping(form, countryCode) {
  return Object.keys(form.mapping).find((key) => form.mapping[key] === countryCode);
}
